export default {
    NEW: 1,
    MODIFY: 2,
    VOID: 3,
}
